export enum OrderSortingType {
	CustomerIdAscending = 0,
	CustomerIdDescending = 1,
	StateAscending = 2,
	StateDescending = 3,
	NameAscending = 4,
	NameDescending = 5,
	OrderIdAscending = 6,
	OrderIdDescending = 7,
	OrderDateAscending = 8,
	OrderDateDescending = 9,
	ShippingDateAscending = 10,
	ShippingDateDescending = 11,
	FertigerAscending = 12,
	FertigerDescending = 13,
}
